
import React from 'react';
import { Card } from '@/components/ui/card';
import { ProfileHeader } from './ProfileHeader';
import { ProfileForm } from './ProfileForm';
import { useProfileData } from '@/hooks/useProfileData';

interface ProfileSectionProps {
  breeder: {
    name: string;
    profileImage: string;
    logo: string;
    location: string;
    description: string;
    subscriptionActive: boolean;
  };
  authLoading: boolean;
}

export const ProfileSection: React.FC<ProfileSectionProps> = ({ breeder, authLoading }) => {
  const {
    formData,
    loading,
    hasChanges,
    handleLocationChange,
    handleInputChange,
    handleBreedAdd,
    handleBreedRemove,
    handleImageUpdate,
    handleSaveChanges
  } = useProfileData();

  return (
    <Card className="overflow-hidden relative">
      <ProfileHeader
        coverImage={formData.coverImage}
        profileImage={formData.profileImage}
        breederProfileImage={breeder.profileImage}
        onImageUpdate={handleImageUpdate}
      />
      
      <ProfileForm
        formData={formData}
        loading={loading}
        hasChanges={hasChanges}
        subscriptionActive={breeder.subscriptionActive}
        authLoading={authLoading}
        onLocationChange={handleLocationChange}
        onInputChange={handleInputChange}
        onBreedAdd={handleBreedAdd}
        onBreedRemove={handleBreedRemove}
        onSaveChanges={handleSaveChanges}
      />
    </Card>
  );
};
